export enum HowGroupsWorkDisplay {
  selfScoreBenchmark = 0,
  selfScoreBenchmarkRespondents = 1,
  groupDisplay = 2,
}
